import React from 'react';
import { Route, Redirect } from 'react-router';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';

interface GuardedRouteProps {
  component: React.ComponentType<any>;
  isAllowed: boolean;
  redirectTo?: string;
  message?: string;
  snackbarType?: EAlertType;
  snackbarPosition?: ESnackBarPosition;
  [key: string]: any; // for Route props like path, exact, etc.
}

const GuardedRoute: React.FC<GuardedRouteProps> = ({
  component: Component,
  isAllowed,
  redirectTo = '/',
  message,
  snackbarType = EAlertType.ERROR,
  snackbarPosition = ESnackBarPosition.TOP,
  ...rest
}) => (
  <Route
    id='guardedRoute-wrapper'
    {...rest}
    render={(props) =>
      isAllowed ? (
        <Component {...props} />
      ) : (
        (() => {
          if (message) {
            showAlertSnackBar(snackbarType, snackbarPosition, message);
          }
          return <Redirect to={redirectTo} />;
        })()
      )
    }
  />
);

export default GuardedRoute;
